import { performRequestSecond, performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';
import Cookies from 'universal-cookie';
const cookie = new Cookies();

export const loginLogoutEvent = (is_login = false, tenant_id = '', tenant_selected = false) => {
  const [tenantId] = getTenantDetails();
  tenant_id = tenant_id ? tenant_id : tenantId;
  let url = `${apiEndPoints.log_in_out}?tenant_id=${tenantId}&is_login=${is_login}&tenant_selected=${tenant_selected}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const globalSearchEvent = (
  search_keyword = '',
  is_content = false,
  is_view_all = false,
  excludeFromLoading = false,
  configOptions = {},
  modules = '',
  page = 1,
  page_size = 50,
  sort_by = '',
  sort_order = '',
  start_date = '',
  end_date = '',
  file_type = '',
  modules_param = '',
  case_id = ''
) => {
  const tenantId = cookie.get('tenantId') || null;
  let url = `${apiEndPoints.globalSearch}?tenant_id=${tenantId}&search_keyword=${encodeURI(
    search_keyword
  )}&is_content=${is_content}&is_view_all=${is_view_all}`;
  if (modules) {
    url += `&modules=${modules}`; // modules expects comma-separated raw values like case,contact
  }
  if (case_id) {
    url += `&case_id=${case_id}`;
  }
  if (page) {
    url += `&page=${page}`;
  }
  if (page_size) {
    url += `&page_size=${page_size}`;
  }
  if (sort_by) {
    url += `&sort_by=${sort_by}`;
  }
  if (sort_order) {
    url += `&sort_order=${sort_order}`;
  }
  if (start_date) {
    url += `&start_date=${start_date}`;
  }
  if (end_date) {
    url += `&end_date=${end_date}`;
  }
  if (file_type) {
    url += `&file_type=${file_type}`;
  }
  if (modules_param) {
    url += `&modules=${modules_param}`;
  }
  return performRequestThird(apiEndPoints.methodType.GET, url, {}, '', true, excludeFromLoading, configOptions.cancelToken);
};

export const quickSearchEventV2 = (
  query = '',
  excludeFromLoading = false,
  configOptions = {},
  res_type = [],
  file_type = '',
  timezone_offset = null,
  firm_phone_number = null
) => {
  const tenantId = cookie.get('tenantId') || null;

  // tenant_id goes in query string
  const url = `${apiEndPoints.quickSearchV2}?tenant_id=${tenantId}`;

  // Everything else goes in request body
  const payload = {
    query: query,
  };

  if (timezone_offset) {
    payload.timezone_offset = timezone_offset;
  }

  // res_type is now an array
  if (res_type && Array.isArray(res_type) && res_type.length > 0) {
    payload.res_type = res_type;
  }

  if (file_type) {
    payload.file_type = file_type;
  }

  if (firm_phone_number) {
    payload.firm_phone_number = firm_phone_number;
  }

  return performRequestSecond(apiEndPoints.methodType.POST, url, payload, '', true, excludeFromLoading, configOptions.cancelToken);
};

export const globalSearchEventV2 = (
  query = '',
  excludeFromLoading = false,
  configOptions = {},
  page = 0,
  size = 50,
  res_type = [],
  file_type = '',
  sort_by = '',
  sort_order = '',
  start_date = '',
  end_date = '',
  timezone_offset = null,
  firm_phone_number = null
) => {
  const tenantId = cookie.get('tenantId') || null;

  // tenant_id goes in query string
  const url = `${apiEndPoints.globalSearchV2}?tenant_id=${tenantId}`;

  // Everything else goes in request body
  const payload = {
    query: query,
  };

  if (timezone_offset) {
    payload.timezone_offset = timezone_offset;
  }

  if (page !== undefined && page !== null) {
    payload.page = page;
  }

  if (size !== undefined && size !== null) {
    payload.size = size;
  }

  // res_type is an array from MultiSelect
  if (res_type && Array.isArray(res_type) && res_type.length > 0) {
    payload.res_type = res_type;
  }

  if (file_type) {
    payload.file_type = file_type;
  }

  if (sort_by) {
    payload.sort_by = sort_by;
  }

  if (sort_order) {
    payload.sort_order = sort_order;
  }

  if (start_date) {
    payload.start_date = start_date;
  }

  if (end_date) {
    payload.end_date = end_date;
  }

  if (firm_phone_number) {
    payload.firm_phone_number = firm_phone_number;
  }

  return performRequestSecond(apiEndPoints.methodType.POST, url, payload, '', true, excludeFromLoading, configOptions.cancelToken);
};

export const totalCountEvent = async (
  module = ' ',
  case_id = '',
  contact_id = '',
  phone_number = '',
  pk = '',
  excludeFromLoading = false
) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenantSk = cookie.get('tenantSk') || null;
  let url = `${
    apiEndPoints.totalCount
  }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&module=${module}&case_id=${case_id}&contact_id=${contact_id}&phone_number=${phone_number}&pk=${
    pk ? pk : ''
  }`;
  return await performRequestThird(apiEndPoints.methodType.GET, url, {}, '', true, excludeFromLoading);
};

export const totalCountClientEvent = async (module = ' ', contact_id = '') => {
  const tenantId = cookie.get('tenantId') || null;
  const tenantSk = cookie.get('tenantSk') || null;
  let url = `${apiEndPoints.totalCount}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&module=${module}&contact_id=${contact_id}`;
  return await performRequestThird(apiEndPoints.methodType.GET, url);
};

// Fuzzy Suggestions API
export const fetchFuzzySuggestions = (category = 'case', search_keyword = '', excludeFromLoading = false) => {
  const [tenantId] = getTenantDetails();
  const params = new URLSearchParams();
  params.set('tenant_id', tenantId || '');
  params.set('search_keyword', search_keyword || '');
  params.set('category', category || '');
  params.set('limit', 10);
  const url = `${apiEndPoints.fetchSuggestions}?${params.toString()}`;
  // Gateway 3
  return performRequestThird(apiEndPoints.methodType.GET, url, {}, '', true, excludeFromLoading);
};
export const getDomainStatus = (data) => {
  let url = `/sub-domain-status-check`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const getStorageInformation = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `/storage-info?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const postActivityLog = (data, is_fe_activity = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `/create-activity-log?tenant_id=${tenantId}&tenant_sk=${tenantSk}&is_fe_activity=${is_fe_activity}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data, '', true, true);
};

export const totalCountReferredToContact = async (
  module = ' ',
  is_referral_entity = false,
  case_id = '',
  contact_id = '',
  phone_number = '',
  pk = '',
  excludeFromLoading = false
) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenantSk = cookie.get('tenantSk') || null;
  let url = `${
    apiEndPoints.totalCount
  }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&module=${module}&referral_entity=${is_referral_entity}&case_id=${case_id}&contact_id=${contact_id}&phone_number=${phone_number}&pk=${
    pk ? pk : ''
  }`;
  return await performRequestThird(apiEndPoints.methodType.GET, url, {}, '', true, excludeFromLoading);
};
